import React, { Component } from 'react';
import {Button, Row, Col} from 'react-bootstrap';
import { handleFieldChange } from "../../../../../../Utils";
import FieldGroup from '../../../../../../components/FieldGroup';
import Icon from '../../../../../../components/Icon';
import SelectWrap from "../../../../../../components/SelectWrap";
import FormOverlay from "../../../../../../components/FormOverlay";
import countries from "../../../../../../data/countries";


class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.cutoff) {
            this.state = {
                update: true,
                id: this.props.cutoff.id,
                affids: this.props.cutoff.affids,
                country: this.props.cutoff.country ? this.props.cutoff.country.split(',') : '',
                base: this.props.cutoff.base,
                weekend: this.props.cutoff.weekend,
            };
        }
        else {
            this.state = {
                affids: '',
                country: '',
                base: '',
                weekend: '',
            };
        }



        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);

    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit({ ...this.state });
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <Row>
                        <Col lg={3}>
                            <SelectWrap
                                values={this.props.affidValues}
                                label="Affid:"
                                name="affids"
                                onChange={this.handleFieldChange}
                                value={this.state.affids}
                                multi
                            />
                        </Col>
                        <Col lg={3}>
                            <SelectWrap
                                values={countries}
                                label="Countries:"
                                name="country"
                                onChange={this.handleFieldChange}
                                value={this.state.country}
                                multi
                            />
                        </Col>
                        <Col lg={3}>
                            <FieldGroup
                                name="base"
                                label="Base:"
                                onChange={this.handleFieldChange}
                                value={this.state.base}
                                type={'number'}
                                step={'0.01'}
                                min={'0'}
                                max={'100'}
                                required
                            />
                        </Col>
                        <Col lg={3}>
                            <FieldGroup
                                name="weekend"
                                label="Weekend:"
                                onChange={this.handleFieldChange}
                                value={this.state.weekend}
                                type={'number'}
                                step={'0.01'}
                                min={'0'}
                                max={'100'}
                                required
                            />
                        </Col>
                    </Row>
                    <Button bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/PcCutoff/components/Affid/components/Form/index.js